import { render } from "./LeadsStats.vue?vue&type=template&id=b23b77a6&scoped=true"
import script from "./LeadsStats.vue?vue&type=script&lang=js"
export * from "./LeadsStats.vue?vue&type=script&lang=js"

import "./LeadsStats.vue?vue&type=style&index=0&id=b23b77a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b23b77a6"]])

export default __exports__